export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AudioLanguages: { input: import("./scalars").AudioLanguages; output: import("./scalars").AudioLanguages; }
  BigInt: { input: string; output: string; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  Details: { input: import("./scalars").DetailsObject; output: import("./scalars").DetailsObject; }
  EmailAddress: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Keywords: { input: import("./scalars").Keywords; output: import("./scalars").Keywords; }
  NonNegativeInt: { input: number; output: number; }
  PayoutTemplate: { input: any; output: any; }
  Synopsis: { input: import("./scalars").Synopsis; output: import("./scalars").Synopsis; }
  Titles: { input: import("./scalars").TitleMap; output: import("./scalars").TitleMap; }
  UUID: { input: string; output: string; }
};

export type AccountBuyerObjectType = {
  __typename?: 'AccountBuyerObjectType';
  audioOutputFormat?: Maybe<AudioOutputFormat>;
  billingEmail: Scalars['String']['output'];
  broadcastCountries: BroadcastCountriesType;
  broadcastLanguage: LanguageIsoCode;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: VideoOutputBitrate;
  videoOutputFormat: VideoOutputFormat;
};

export type AccountSellerObjectType = {
  __typename?: 'AccountSellerObjectType';
  billingEmail: Scalars['String']['output'];
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  metrics: SellerMetrics;
  postalAddress: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatId: Scalars['String']['output'];
};

export type AddToCartInput = {
  excludeEpisodeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  language: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type AssetBuilder = {
  __typename?: 'AssetBuilder';
  audioLanguage: Scalars['String']['output'];
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  buyer: Buyer;
  contents: Array<Contents>;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  license?: Maybe<License>;
  status: Scalars['String']['output'];
  subtitleLanguage: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export enum AudioOutputFormat {
  Aac = 'AAC',
  Ac3 = 'AC3',
  Aiff = 'AIFF',
  Eac3 = 'EAC3',
  Wav = 'WAV'
}

export type AudioTrack = {
  __typename?: 'AudioTrack';
  bitrate: Scalars['String']['output'];
  languages: Array<AudioTrackLanguage>;
  mode: Scalars['String']['output'];
  sampleRate: Scalars['Int']['output'];
  subtitleExtracted?: Maybe<GeneratedSubtitleSourceFile>;
  subtitlesTranslated: Array<GeneratedSubtitleSourceFile>;
  trackNumber: Scalars['Int']['output'];
};

export type AudioTrackLanguage = {
  __typename?: 'AudioTrackLanguage';
  code: LanguageIsoCode;
  dominant: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
};

export type BackofficeBuyerObjectType = {
  __typename?: 'BackofficeBuyerObjectType';
  audioOutputFormat?: Maybe<AudioOutputFormat>;
  billingEmail: Scalars['String']['output'];
  broadcastCountries: BroadcastCountriesType;
  broadcastLanguage: LanguageIsoCode;
  broadcastType: NestBroadcastType;
  businessProvider?: Maybe<BuyerBusinessProvider>;
  businessProviderId?: Maybe<Scalars['String']['output']>;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hourCost: Scalars['Float']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesDuration: Scalars['Int']['output'];
  payinIban?: Maybe<Scalars['String']['output']>;
  payoutTemplate: Scalars['JSON']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  replayRights: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: VideoOutputBitrate;
  videoOutputFormat: VideoOutputFormat;
};

export type BackofficeCoverSourceFile = BackofficeSourceFile & {
  __typename?: 'BackofficeCoverSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  linkedProgram?: Maybe<BackofficeProgram>;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type BackofficeCreditSourceFile = BackofficeSourceFile & {
  __typename?: 'BackofficeCreditSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  linkedProgram?: Maybe<BackofficeProgram>;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type BackofficeMetadataSourceFile = BackofficeSourceFile & {
  __typename?: 'BackofficeMetadataSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  parseStatus: SourceFileParseStatus;
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type BackofficeProgram = {
  __typename?: 'BackofficeProgram';
  audioLanguages?: Maybe<Array<LanguageIsoCode>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editorialization?: Maybe<ProgramEditorialization>;
  emptyEpisodes?: Maybe<Scalars['Int']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesQuantity?: Maybe<Scalars['Int']['output']>;
  files: BackofficeProgramFiles;
  identifier: Identifier;
  lifecycle?: Maybe<ProgramLifecycle>;
  parent?: Maybe<BackofficeProgram>;
  seller: BackofficeSellerObjectType;
};

export type BackofficeProgramFiles = {
  __typename?: 'BackofficeProgramFiles';
  coverImageFile?: Maybe<BackofficeSourceFile>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  creditRollFile?: Maybe<BackofficeSourceFile>;
  masterFile?: Maybe<BackofficeSourceFile>;
  masterSubtitles: Array<ProgramSubtitle>;
  trailerFile?: Maybe<BackofficeSourceFile>;
  trailerSubtitles: Array<ProgramSubtitle>;
};

export type BackofficeSellerObjectType = {
  __typename?: 'BackofficeSellerObjectType';
  billingEmail: Scalars['String']['output'];
  businessProvider?: Maybe<SellerBusinessProvider>;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  commissionRate: Scalars['Float']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  payoutTemplate: Scalars['JSON']['output'];
  postalAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type BackofficeSourceFile = {
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type BackofficeSubtitleSourceFile = BackofficeSourceFile & {
  __typename?: 'BackofficeSubtitleSourceFile';
  audioTrackNumber?: Maybe<Scalars['Int']['output']>;
  contentType: SourceFileContentType;
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  language?: Maybe<LanguageIsoCode>;
  linkStatus: SourceFileLinkStatus;
  linkedProgram?: Maybe<BackofficeProgram>;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  subtitlesTranslated: Array<GeneratedSubtitleSourceFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type BackofficeUpdateProgramInput = {
  coverImageFileId?: InputMaybe<Scalars['UUID']['input']>;
  creditRollFileId?: InputMaybe<Scalars['UUID']['input']>;
  masterFileId?: InputMaybe<Scalars['UUID']['input']>;
  masterSubtitles?: InputMaybe<Array<ProgramSubtitleInput>>;
  trailerFileId?: InputMaybe<Scalars['UUID']['input']>;
  trailerSubtitles?: InputMaybe<Array<ProgramSubtitleInput>>;
};

export type BackofficeVideoSourceFile = BackofficeSourceFile & {
  __typename?: 'BackofficeVideoSourceFile';
  audioTracks: Array<AudioTrack>;
  contentType: SourceFileContentType;
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  linkedProgram?: Maybe<BackofficeProgram>;
  mediainfo?: Maybe<Scalars['JSON']['output']>;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
  videoTrack?: Maybe<VideoTrack>;
};

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type BroadcastCountries = {
  __typename?: 'BroadcastCountries';
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BroadcastCountriesInput = {
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BroadcastCountriesType = {
  __typename?: 'BroadcastCountriesType';
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BusinessProvider = {
  __typename?: 'BusinessProvider';
  bankAccountDetails: BankAccountDetails;
  billingEmail: Scalars['EmailAddress']['output'];
  buyers: Array<Buyer>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesQuantity: Scalars['Int']['output'];
  postalAddress: Scalars['String']['output'];
  programsDuration: Scalars['Int']['output'];
  sellers: Array<Seller>;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
};

export type BusinessProviderFiltersInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  licensesQuantity?: InputMaybe<RangeInput>;
  metricsDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  metricsDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  programsDuration?: InputMaybe<RangeInput>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessProviderOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  licensesQuantity?: InputMaybe<SearchDirection>;
  programsDuration?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type Buyer = {
  __typename?: 'Buyer';
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  billingEmail: Scalars['EmailAddress']['output'];
  broadcastCountries: BroadcastCountries;
  broadcastLanguage: Scalars['String']['output'];
  broadcastType: Scalars['String']['output'];
  businessProvider?: Maybe<BusinessProvider>;
  contactEmail: Scalars['EmailAddress']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hourCost: Scalars['Float']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesDuration: Scalars['Int']['output'];
  payinIban: Scalars['String']['output'];
  payoutTemplate: Scalars['PayoutTemplate']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  replayRights: Scalars['Boolean']['output'];
  tenant: Tenant;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export type BuyerAccountMutations = {
  __typename?: 'BuyerAccountMutations';
  update: AccountBuyerObjectType;
};


export type BuyerAccountMutationsUpdateArgs = {
  input: UpdateBuyerAccountInput;
};

export enum BuyerAudioOutputFormat {
  Aac = 'AAC',
  Ac3 = 'AC3',
  Aiff = 'AIFF',
  Eac3 = 'EAC3',
  Wav = 'WAV'
}

export type BuyerBackofficeMutations = {
  __typename?: 'BuyerBackofficeMutations';
  create: BackofficeBuyerObjectType;
  update: BackofficeBuyerObjectType;
};


export type BuyerBackofficeMutationsCreateArgs = {
  input: CreateBuyerInput;
};


export type BuyerBackofficeMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateBuyerInput;
};

export type BuyerBusinessProvider = {
  __typename?: 'BuyerBusinessProvider';
  contactName?: Maybe<Scalars['String']['output']>;
  identifier: Identifier;
};

export type BuyerClaimFiltersInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerMutations = {
  __typename?: 'BuyerMutations';
  account: BuyerAccountMutations;
  backoffice: BuyerBackofficeMutations;
};

export type BuyerQueries = {
  __typename?: 'BuyerQueries';
  account?: Maybe<AccountBuyerObjectType>;
  backoffice?: Maybe<BackofficeBuyerObjectType>;
};

export type BuyerSearchFilterInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  mainBroadcastCountry?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerSearchOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  mainBroadcastCountry?: InputMaybe<SearchDirection>;
  publicName?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type BuyerSearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export enum BuyerVideoOutputBitrate {
  B_2_5 = 'B_2_5',
  B_5 = 'B_5',
  B_25 = 'B_25',
  B_30 = 'B_30',
  B_50 = 'B_50'
}

export enum BuyerVideoOutputFormat {
  Mov = 'MOV',
  Mp4 = 'MP4',
  Mxf = 'MXF'
}

export type BuyersQueries = {
  __typename?: 'BuyersQueries';
  backoffice: SearchBackofficeBuyersOutput;
};


export type BuyersQueriesBackofficeArgs = {
  filter?: InputMaybe<BuyerSearchFilterInput>;
  orderBy?: InputMaybe<BuyerSearchOrderByInput>;
  pagination?: InputMaybe<BuyerSearchPaginationInput>;
};

export type Cart = {
  __typename?: 'Cart';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  programs: Array<CartProgram>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CartBillingMutations = {
  __typename?: 'CartBillingMutations';
  addToCart: CurrentCart;
  removeFromCart: CurrentCart;
  updateCart: CurrentCart;
};


export type CartBillingMutationsAddToCartArgs = {
  input: AddToCartInput;
};


export type CartBillingMutationsRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};


export type CartBillingMutationsUpdateCartArgs = {
  input: UpdateCartInput;
};

export type CartMutations = {
  __typename?: 'CartMutations';
  billing: CartBillingMutations;
};

export type CartProgram = {
  __typename?: 'CartProgram';
  language: Scalars['String']['output'];
  program: Program;
};

export type CatalogFormat = {
  __typename?: 'CatalogFormat';
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime']['output'];
  editorialization?: Maybe<EditorializationObjectType>;
  files: CatalogFormatFiles;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  otherProductionCountries: Array<OtherProductionCountryObjectType>;
  production?: Maybe<ProductionObjectType>;
  rightExclusivity: Scalars['Boolean']['output'];
  seller?: Maybe<PublicSeller>;
  timeslot: FormatTimeslot;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CatalogFormatFiles = {
  __typename?: 'CatalogFormatFiles';
  coverUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<MasterTechnicalDetails>;
  masterUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  trailerUrl?: Maybe<Scalars['String']['output']>;
};

export type CatalogProgram = {
  __typename?: 'CatalogProgram';
  audioLanguages?: Maybe<Array<LanguageIsoCode>>;
  category: Category;
  duration?: Maybe<Scalars['Int']['output']>;
  editorialization?: Maybe<ProgramEditorialization>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesPrice?: Maybe<Scalars['Float']['output']>;
  episodesQuantity?: Maybe<Scalars['Int']['output']>;
  files: CatalogProgramFiles;
  genres: Array<Genre>;
  identifier: Identifier;
  isSegmentable?: Maybe<Scalars['Boolean']['output']>;
  licensesQuantity: Scalars['Int']['output'];
  lifecycle?: Maybe<PublicProgramLifecycle>;
  parent?: Maybe<CatalogProgram>;
  price?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<ProgramProduction>;
  publicSeller: ProgramPublicSeller;
};


export type CatalogProgramEpisodesPriceArgs = {
  excludedEpisodeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CatalogProgramFiles = {
  __typename?: 'CatalogProgramFiles';
  coverUrl?: Maybe<Scalars['String']['output']>;
  creditRollUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<ProgramMasterTechnicalDetails>;
  masterUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  trailerUrl?: Maybe<Scalars['String']['output']>;
};

export enum CatalogSearchDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  Random = 'RANDOM'
}

export type Category = {
  __typename?: 'Category';
  catchPhrase: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CategoryProgram = {
  __typename?: 'CategoryProgram';
  catchPhrase: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  license?: Maybe<License>;
  message: Scalars['String']['output'];
  status: ClaimStatusOutput;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClaimFiltersInput = {
  buyer?: InputMaybe<BuyerClaimFiltersInput>;
  licenseId?: InputMaybe<Scalars['UUID']['input']>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  program?: InputMaybe<ProgramClaimFiltersInput>;
  seller?: InputMaybe<SellerClaimFiltersInput>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClaimStatus>;
};

export enum ClaimOrderFieldsInput {
  BuyerContactEmail = 'BUYER_CONTACT_EMAIL',
  BuyerContactName = 'BUYER_CONTACT_NAME',
  BuyerId = 'BUYER_ID',
  BuyerLegalName = 'BUYER_LEGAL_NAME',
  BuyerPublicName = 'BUYER_PUBLIC_NAME',
  CreatedAt = 'CREATED_AT',
  LicenseId = 'LICENSE_ID',
  ProgramTitle = 'PROGRAM_TITLE',
  SellerLegalName = 'SELLER_LEGAL_NAME',
  Sku = 'SKU',
  Status = 'STATUS'
}

export type ClaimOrderInput = {
  direction: SearchDirection;
  field: ClaimOrderFieldsInput;
};

export enum ClaimStatus {
  Opened = 'OPENED',
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ClaimStatusInput {
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ClaimStatusOutput {
  Opened = 'OPENED',
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ContentType {
  Format = 'FORMAT',
  Program = 'PROGRAM'
}

export type Contents = {
  __typename?: 'Contents';
  coverUrl?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  subtitleUrl?: Maybe<Scalars['String']['output']>;
  titles: Scalars['Titles']['output'];
  videoUrl: Scalars['String']['output'];
};

export enum CountryExclusionTypeObjectType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export enum CountryIsoCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Uk = 'UK',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateBuyerInput = {
  audioOutputFormat?: InputMaybe<AudioOutputFormat>;
  billingEmail: Scalars['String']['input'];
  broadcastCountries: BroadcastCountriesInput;
  broadcastLanguage: LanguageIsoCode;
  broadcastType: NestBroadcastType;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  hourCost: Scalars['Float']['input'];
  legalName: Scalars['String']['input'];
  licensesDuration: Scalars['Int']['input'];
  payoutTemplate: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  publicName: Scalars['String']['input'];
  replayRights: Scalars['Boolean']['input'];
  vatId: Scalars['String']['input'];
  videoOutputBitrate: VideoOutputBitrate;
  videoOutputFormat: VideoOutputFormat;
};

export type CreateClaimInput = {
  licenseId: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
};

export type CreateExcludedCountriesTemplateInput = {
  excludedCountries: Array<ExcludedCountryInputType>;
  templateName: Scalars['String']['input'];
};

/** Create multipart upload response */
export type CreateMultipartUploadResponse = {
  __typename?: 'CreateMultipartUploadResponse';
  key: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
};

export type CreateSellerInput = {
  billingEmail: Scalars['String']['input'];
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  commissionRate: Scalars['Float']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  payoutTemplate: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};

export type CurrentCart = {
  __typename?: 'CurrentCart';
  identifier: CurrentCartIdentifier;
  price: Scalars['Float']['output'];
  programs: Array<CurrentCartProgram>;
  quantity: Scalars['Int']['output'];
};

export type CurrentCartIdentifier = {
  __typename?: 'CurrentCartIdentifier';
  id: Scalars['UUID']['output'];
};

export type CurrentCartProgram = {
  __typename?: 'CurrentCartProgram';
  language: LanguageIsoCode;
  price: Scalars['Float']['output'];
  program: CatalogProgram;
};

export type DashboardCoverSourceFile = DashboardSourceFile & {
  __typename?: 'DashboardCoverSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type DashboardCreditSourceFile = DashboardSourceFile & {
  __typename?: 'DashboardCreditSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type DashboardFormat = {
  __typename?: 'DashboardFormat';
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  editorialization: EditorializationObjectType;
  excludedCountries: Array<FormatExcludedCountry>;
  files: DashboardFormatFiles;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  lifecycle?: Maybe<LifecycleObjectType>;
  otherProductionCountries: Array<OtherProductionCountryObjectType>;
  production?: Maybe<ProductionObjectType>;
  seller?: Maybe<SellerObjectType>;
  sellerId: Scalars['String']['output'];
  timeslot: FormatTimeslot;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DashboardFormatFiles = {
  __typename?: 'DashboardFormatFiles';
  coverUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<MasterTechnicalDetails>;
  masterUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  trailerUrl?: Maybe<Scalars['String']['output']>;
};

export type DashboardMetadataSourceFile = DashboardSourceFile & {
  __typename?: 'DashboardMetadataSourceFile';
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  parseStatus: SourceFileParseStatus;
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type DashboardProgram = {
  __typename?: 'DashboardProgram';
  audioLanguages?: Maybe<Array<LanguageIsoCode>>;
  category: Category;
  duration?: Maybe<Scalars['Int']['output']>;
  editorialization?: Maybe<ProgramEditorialization>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesQuantity?: Maybe<Scalars['Int']['output']>;
  excludedCountries: Array<ProgramExcludedCountry>;
  files: DashboardProgramFiles;
  genres: Array<Genre>;
  identifier: Identifier;
  isSegmentable?: Maybe<Scalars['Boolean']['output']>;
  licensesQuantity?: Maybe<Scalars['Int']['output']>;
  lifecycle?: Maybe<ProgramLifecycle>;
  parent?: Maybe<DashboardProgram>;
  production?: Maybe<ProgramProduction>;
};

export type DashboardProgramFiles = {
  __typename?: 'DashboardProgramFiles';
  coverUrl?: Maybe<Scalars['String']['output']>;
  creditRollUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<ProgramMasterTechnicalDetails>;
  masterUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  trailerUrl?: Maybe<Scalars['String']['output']>;
};

export type DashboardSourceFile = {
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type DashboardSubtitleSourceFile = DashboardSourceFile & {
  __typename?: 'DashboardSubtitleSourceFile';
  audioTrackNumber?: Maybe<Scalars['Int']['output']>;
  contentType: SourceFileContentType;
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  language?: Maybe<LanguageIsoCode>;
  linkStatus: SourceFileLinkStatus;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  subtitlesTranslated: Array<GeneratedSubtitleSourceFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type DashboardVideoSourceFile = DashboardSourceFile & {
  __typename?: 'DashboardVideoSourceFile';
  audioTracks: Array<AudioTrack>;
  contentType: SourceFileContentType;
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  linkStatus: SourceFileLinkStatus;
  mediainfo?: Maybe<Scalars['JSON']['output']>;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
  videoTrack?: Maybe<VideoTrack>;
};

export type DateRangeInput = {
  max?: InputMaybe<Scalars['Date']['input']>;
  min?: InputMaybe<Scalars['Date']['input']>;
};

export type DeleteBusinessProviderResult = {
  __typename?: 'DeleteBusinessProviderResult';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteOutput = {
  __typename?: 'DeleteOutput';
  id: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteSourceFileOutput = {
  __typename?: 'DeleteSourceFileOutput';
  id: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type EditorializationInput = {
  durationDescription?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditorializationObjectType = {
  __typename?: 'EditorializationObjectType';
  durationDescription?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  synopsis: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExcludedCountriesTemplateFiltersInput = {
  excludedCountries: Array<ExcludedCountryInputType>;
};

export type ExcludedCountriesTemplateObjectType = {
  __typename?: 'ExcludedCountriesTemplateObjectType';
  createdAt: Scalars['DateTime']['output'];
  excludedCountries: Array<ExcludedCountryObjectType>;
  identifier: Identifier;
  templateName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ExcludedCountriesTemplateOrderFieldsInput {
  Name = 'NAME'
}

export type ExcludedCountriesTemplateOrderInput = {
  direction: SearchDirection;
  field: ExcludedCountriesTemplateOrderFieldsInput;
};

export type ExcludedCountry = {
  __typename?: 'ExcludedCountry';
  countryISOCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ExcludedCountryInput = {
  countryISOCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ExcludedCountryInputType = {
  countryISOCode: CountryIsoCode;
  exclusionType: CountryExclusionTypeObjectType;
};

export type ExcludedCountryObjectType = {
  __typename?: 'ExcludedCountryObjectType';
  countryISOCode: CountryIsoCode;
  exclusionType: CountryExclusionTypeObjectType;
};

export enum ExclusionType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export type FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FormatBackofficeMutations = {
  __typename?: 'FormatBackofficeMutations';
  delete: DeleteOutput;
};


export type FormatBackofficeMutationsDeleteArgs = {
  id: Scalars['UUID']['input'];
};

export type FormatDashboardMutations = {
  __typename?: 'FormatDashboardMutations';
  update: FormatObjectType;
};


export type FormatDashboardMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateFormatInput;
};

export type FormatExcludedCountry = {
  __typename?: 'FormatExcludedCountry';
  countryISOCode: Scalars['String']['output'];
  exclusionType: Scalars['String']['output'];
};

export type FormatFiles = {
  __typename?: 'FormatFiles';
  coverImageFile?: Maybe<BackofficeSourceFile>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  masterFile?: Maybe<BackofficeSourceFile>;
  trailerFile?: Maybe<BackofficeSourceFile>;
};

export type FormatMutations = {
  __typename?: 'FormatMutations';
  backoffice: FormatBackofficeMutations;
  dashboard: FormatDashboardMutations;
};

export type FormatObjectType = {
  __typename?: 'FormatObjectType';
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  editorialization: EditorializationObjectType;
  excludedCountries: Array<FormatExcludedCountry>;
  files: FormatFiles;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  lifecycle?: Maybe<LifecycleObjectType>;
  production?: Maybe<ProductionObjectType>;
  seller?: Maybe<SellerObjectType>;
  sellerId: Scalars['String']['output'];
  timeslot: FormatTimeslot;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FormatQueries = {
  __typename?: 'FormatQueries';
  backoffice?: Maybe<FormatObjectType>;
  catalog: CatalogFormat;
  dashboard?: Maybe<DashboardFormat>;
};


export type FormatQueriesBackofficeArgs = {
  id: Scalars['UUID']['input'];
};


export type FormatQueriesCatalogArgs = {
  id: Scalars['UUID']['input'];
};


export type FormatQueriesDashboardArgs = {
  id: Scalars['UUID']['input'];
};

export enum FormatTimeslot {
  AccessPrime = 'ACCESS_PRIME',
  Daytime = 'DAYTIME',
  LateNight = 'LATE_NIGHT',
  PrimeTime = 'PRIME_TIME'
}

export type FormatsQueries = {
  __typename?: 'FormatsQueries';
  backoffice: SearchBackofficeFormatsOutput;
  catalog: SearchCatalogFormatsOutput;
  dashboard: SearchDashboardFormatsOutput;
};


export type FormatsQueriesBackofficeArgs = {
  filter?: InputMaybe<SearchBackofficeFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};


export type FormatsQueriesCatalogArgs = {
  filter?: InputMaybe<SearchCatalogFormatsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};


export type FormatsQueriesDashboardArgs = {
  filter?: InputMaybe<SearchDashboardFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};

export type GeneratedSubtitleSourceFile = {
  __typename?: 'GeneratedSubtitleSourceFile';
  audioTrackNumber?: Maybe<Scalars['Int']['output']>;
  contentType: SourceFileContentType;
  createdAt: Scalars['DateTime']['output'];
  errorsLog?: Maybe<Array<SourceFileErrorLog>>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  fileType: SourceFileFileType;
  identifier: Identifier;
  ingestStatus: SourceFileIngestStatus;
  language?: Maybe<LanguageIsoCode>;
  linkStatus: SourceFileLinkStatus;
  originalFileName: Scalars['String']['output'];
  sellerId: Scalars['String']['output'];
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: SourceFileUploadStatus;
};

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type GenreProgram = {
  __typename?: 'GenreProgram';
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type Identifier = {
  __typename?: 'Identifier';
  id: Scalars['UUID']['output'];
  sku: Scalars['Int']['output'];
};

export type IntRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export enum LanguageIsoCode {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Af = 'AF',
  Ak = 'AK',
  Am = 'AM',
  An = 'AN',
  Ar = 'AR',
  As = 'AS',
  Av = 'AV',
  Ay = 'AY',
  Az = 'AZ',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  Bi = 'BI',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Ca = 'CA',
  Ce = 'CE',
  Ch = 'CH',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cy = 'CY',
  Da = 'DA',
  De = 'DE',
  Dv = 'DV',
  Dz = 'DZ',
  Ee = 'EE',
  El = 'EL',
  En = 'EN',
  Eo = 'EO',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fa = 'FA',
  Ff = 'FF',
  Fi = 'FI',
  Fj = 'FJ',
  Fo = 'FO',
  Fr = 'FR',
  Fy = 'FY',
  Ga = 'GA',
  Gd = 'GD',
  Gl = 'GL',
  Gn = 'GN',
  Gu = 'GU',
  Gv = 'GV',
  Ha = 'HA',
  He = 'HE',
  Hi = 'HI',
  Ho = 'HO',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Hy = 'HY',
  Hz = 'HZ',
  Ia = 'IA',
  Id = 'ID',
  Ie = 'IE',
  Ig = 'IG',
  Ii = 'II',
  Ik = 'IK',
  Io = 'IO',
  Is = 'IS',
  It = 'IT',
  Iu = 'IU',
  Ja = 'JA',
  Jv = 'JV',
  Ka = 'KA',
  Kg = 'KG',
  Ki = 'KI',
  Kj = 'KJ',
  Kk = 'KK',
  Kl = 'KL',
  Km = 'KM',
  Kn = 'KN',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Ku = 'KU',
  Kv = 'KV',
  Kw = 'KW',
  Ky = 'KY',
  La = 'LA',
  Lb = 'LB',
  Lg = 'LG',
  Li = 'LI',
  Ln = 'LN',
  Lo = 'LO',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mg = 'MG',
  Mh = 'MH',
  Mi = 'MI',
  Mk = 'MK',
  Ml = 'ML',
  Mn = 'MN',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  My = 'MY',
  Na = 'NA',
  Nb = 'NB',
  Nd = 'ND',
  Ne = 'NE',
  Ng = 'NG',
  Nl = 'NL',
  Nn = 'NN',
  No = 'NO',
  Nr = 'NR',
  Nv = 'NV',
  Ny = 'NY',
  Oc = 'OC',
  Oj = 'OJ',
  Om = 'OM',
  Or = 'OR',
  Os = 'OS',
  Pa = 'PA',
  Pi = 'PI',
  Pl = 'PL',
  Ps = 'PS',
  Pt = 'PT',
  Qu = 'QU',
  Rm = 'RM',
  Rn = 'RN',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sq = 'SQ',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sw = 'SW',
  Ta = 'TA',
  Te = 'TE',
  Tg = 'TG',
  Th = 'TH',
  Ti = 'TI',
  Tk = 'TK',
  Tl = 'TL',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Ts = 'TS',
  Tt = 'TT',
  Tw = 'TW',
  Ty = 'TY',
  Ug = 'UG',
  Uk = 'UK',
  Und = 'UND',
  Ur = 'UR',
  Uz = 'UZ',
  Ve = 'VE',
  Vi = 'VI',
  Vo = 'VO',
  Wa = 'WA',
  Wo = 'WO',
  Xh = 'XH',
  Yi = 'YI',
  Yo = 'YO',
  Za = 'ZA',
  Zh = 'ZH',
  Zu = 'ZU',
  Zxx = 'ZXX'
}

export type LegacySourceFile = {
  __typename?: 'LegacySourceFile';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['Details']['output']>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  seller?: Maybe<Seller>;
  sourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type License = {
  __typename?: 'License';
  assetBuilder?: Maybe<AssetBuilder>;
  broadcastCountry: CountryIsoCode;
  buyer: Buyer;
  clearanceDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  endingDate?: Maybe<Scalars['DateTime']['output']>;
  identifier: Identifier;
  price: Scalars['Float']['output'];
  program: Program;
  seller: Seller;
  transaction: Transaction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LicenseBuyerOrderBy = {
  broadcastCountries?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
};

export enum LicenseIsoCode {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Uk = 'uk',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Xk = 'xk',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

export type LicenseOrderBy = {
  buyer?: InputMaybe<LicenseBuyerOrderBy>;
  createdAt?: InputMaybe<SortOrder>;
  endingDate?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  program?: InputMaybe<LicenseProgramOrderBy>;
  seller?: InputMaybe<LicenseSellerOrderBy>;
  sku?: InputMaybe<SortOrder>;
};

export type LicenseProgramOrderBy = {
  titles?: InputMaybe<SortOrder>;
};

export type LicenseSellerOrderBy = {
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
};

export type LifecycleObjectType = {
  __typename?: 'LifecycleObjectType';
  published: Scalars['Boolean']['output'];
  rightExclusivity: Scalars['Boolean']['output'];
  validated: Scalars['Boolean']['output'];
};

/** List parts response */
export type ListPartsResponse = {
  __typename?: 'ListPartsResponse';
  parts: Array<UploadedPart>;
};

export type MasterTechnicalDetails = {
  __typename?: 'MasterTechnicalDetails';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  audioBitrate?: Maybe<Scalars['String']['output']>;
  audioMode?: Maybe<Scalars['String']['output']>;
  audioSampleRate?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  videoBitrate?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortMultipartUpload: Scalars['Boolean']['output'];
  buyer: BuyerMutations;
  cart: CartMutations;
  completeMultipartUpload: Scalars['Boolean']['output'];
  createBusinessProvider: BusinessProvider;
  createClaim: Claim;
  createExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  createMultipartUpload: CreateMultipartUploadResponse;
  createTransaction: Transaction;
  deleteBusinessProvider: DeleteBusinessProviderResult;
  deleteExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  executeCognitoPostSignup: Scalars['Boolean']['output'];
  format: FormatMutations;
  getSignedUrlsMultipartUpload: Array<Scalars['String']['output']>;
  listParts: ListPartsResponse;
  mediaConvertJobStateChange: Scalars['Boolean']['output'];
  mediaInfoAnalysisCompleted: Scalars['Boolean']['output'];
  processTenantStackCreated: Scalars['Boolean']['output'];
  program: ProgramMutations;
  seller: SellerMutations;
  sourceFile: SourceFileMutations;
  transcribeJobStateChange: Scalars['Boolean']['output'];
  translateJobStateChange: Scalars['Boolean']['output'];
  updateBusinessProvider: BusinessProvider;
  updateClaimStatus: Claim;
  updateExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  updateTransactionStatus: Transaction;
  walletWithdraw: Scalars['Boolean']['output'];
};


export type MutationAbortMultipartUploadArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationCompleteMultipartUploadArgs = {
  key: Scalars['String']['input'];
  parts: Array<UploadedPartInput>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationCreateBusinessProviderArgs = {
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};


export type MutationCreateClaimArgs = {
  input: CreateClaimInput;
};


export type MutationCreateExcludedCountriesTemplateArgs = {
  input: CreateExcludedCountriesTemplateInput;
};


export type MutationCreateMultipartUploadArgs = {
  fileSize: Scalars['BigInt']['input'];
  originalFilename: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  sourceFileContentType: UploadSourceFileContentType;
};


export type MutationCreateTransactionArgs = {
  audioOutputFormat?: InputMaybe<BuyerAudioOutputFormat>;
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  videoOutputBitrate?: InputMaybe<BuyerVideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<BuyerVideoOutputFormat>;
};


export type MutationDeleteBusinessProviderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExcludedCountriesTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationExecuteCognitoPostSignupArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetSignedUrlsMultipartUploadArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  totalParts: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationListPartsArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationMediaConvertJobStateChangeArgs = {
  durationInMs?: InputMaybe<Scalars['Int']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  jobStatus: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationMediaInfoAnalysisCompletedArgs = {
  domain: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  sourceFileId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationProcessTenantStackCreatedArgs = {
  stackId: Scalars['String']['input'];
};


export type MutationTranscribeJobStateChangeArgs = {
  failureReason?: InputMaybe<Scalars['String']['input']>;
  jobName: Scalars['String']['input'];
  jobStatus: Scalars['String']['input'];
};


export type MutationTranslateJobStateChangeArgs = {
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  outputLanguage?: InputMaybe<Scalars['String']['input']>;
  outputS3Bucket?: InputMaybe<Scalars['String']['input']>;
  outputS3Key?: InputMaybe<Scalars['String']['input']>;
  status: TranslateJobStatus;
};


export type MutationUpdateBusinessProviderArgs = {
  bic?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateClaimStatusArgs = {
  id: Scalars['UUID']['input'];
  status: ClaimStatusInput;
};


export type MutationUpdateExcludedCountriesTemplateArgs = {
  input: UpdateExcludedCountriesTemplateInput;
};


export type MutationUpdateTransactionStatusArgs = {
  id: Scalars['UUID']['input'];
  status: TransactionStatusInput;
};


export type MutationWalletWithdrawArgs = {
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum NestBroadcastType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export type OtherProductionCountryInput = {
  countryIsoCode: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type OtherProductionCountryObjectType = {
  __typename?: 'OtherProductionCountryObjectType';
  countryIsoCode: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type PaginatedBusinessProvidersResult = {
  __typename?: 'PaginatedBusinessProvidersResult';
  count: Scalars['Int']['output'];
  items: Array<BusinessProvider>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginatedLicensesResult = {
  __typename?: 'PaginatedLicensesResult';
  count: Scalars['Int']['output'];
  licenses: Array<License>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginatedTransactionsResult = {
  __typename?: 'PaginatedTransactionsResult';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  transactions: Array<Transaction>;
};

export type ProductionObjectType = {
  __typename?: 'ProductionObjectType';
  firstBroadcastDate?: Maybe<Scalars['Date']['output']>;
  productionCountry?: Maybe<Scalars['String']['output']>;
};

export type Program = {
  __typename?: 'Program';
  audioLanguages: Scalars['AudioLanguages']['output'];
  awards?: Maybe<Scalars['String']['output']>;
  casting?: Maybe<Scalars['String']['output']>;
  category: CategoryProgram;
  countriesRight?: Maybe<Array<CountryIsoCode>>;
  coverImageFile?: Maybe<LegacySourceFile>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditRollFile?: Maybe<LegacySourceFile>;
  creditRollUrl?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  emptyEpisodes?: Maybe<Scalars['Int']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesQuantity?: Maybe<Scalars['Int']['output']>;
  excludedCountries?: Maybe<Array<ExcludedCountry>>;
  firstBroadcastDate?: Maybe<Scalars['DateTime']['output']>;
  genres: Array<GenreProgram>;
  identifier: Identifier;
  imdb?: Maybe<Scalars['String']['output']>;
  isExclusive: Scalars['Boolean']['output'];
  isSegmentable: Scalars['Boolean']['output'];
  keywords?: Maybe<Scalars['Keywords']['output']>;
  licensesQuantity?: Maybe<Scalars['Int']['output']>;
  masterFile?: Maybe<LegacySourceFile>;
  masterSubtitles?: Maybe<Array<Subtitle>>;
  originalLanguage?: Maybe<LanguageIsoCode>;
  parent?: Maybe<Program>;
  price?: Maybe<Scalars['Float']['output']>;
  productionCountryIsoCode?: Maybe<Scalars['String']['output']>;
  publicSeller: PublicSeller;
  published: Scalars['Boolean']['output'];
  quality?: Maybe<Scalars['String']['output']>;
  seller: Seller;
  synopsis: Scalars['Synopsis']['output'];
  titles: Scalars['Titles']['output'];
  trailerFile?: Maybe<LegacySourceFile>;
  trailerSubtitles?: Maybe<Array<Subtitle>>;
  updatedAt: Scalars['DateTime']['output'];
  validated: Scalars['Boolean']['output'];
};

export type ProgramAudioTrack = {
  __typename?: 'ProgramAudioTrack';
  bitrate?: Maybe<Scalars['String']['output']>;
  languageDominant?: Maybe<Scalars['String']['output']>;
  languagesList?: Maybe<Array<ProgramAudioTrackLanguage>>;
  mode?: Maybe<Scalars['String']['output']>;
  sampleRate?: Maybe<Scalars['Int']['output']>;
};

export type ProgramAudioTrackLanguage = {
  __typename?: 'ProgramAudioTrackLanguage';
  durationInSeconds?: Maybe<Scalars['Float']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type ProgramBackofficeMutations = {
  __typename?: 'ProgramBackofficeMutations';
  delete: DeleteOutput;
  update: BackofficeProgram;
};


export type ProgramBackofficeMutationsDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type ProgramBackofficeMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: BackofficeUpdateProgramInput;
};

export type ProgramClaimFiltersInput = {
  language?: InputMaybe<LanguageIsoCode>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramDashboardMutations = {
  __typename?: 'ProgramDashboardMutations';
  update: DashboardProgram;
};


export type ProgramDashboardMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateProgramInput;
};

export type ProgramEditorialization = {
  __typename?: 'ProgramEditorialization';
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  synopsis: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProgramEditorializationInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramExcludedCountry = {
  __typename?: 'ProgramExcludedCountry';
  countryCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ProgramExcludedCountryInput = {
  countryIsoCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ProgramLifecycle = {
  __typename?: 'ProgramLifecycle';
  published: Scalars['Boolean']['output'];
  rightExclusivity: Scalars['Boolean']['output'];
  validated: Scalars['Boolean']['output'];
};

export type ProgramMasterTechnicalDetails = {
  __typename?: 'ProgramMasterTechnicalDetails';
  audioTracks?: Maybe<Array<ProgramAudioTrack>>;
  videoTrack?: Maybe<ProgramVideoTrack>;
};

export type ProgramMutations = {
  __typename?: 'ProgramMutations';
  backoffice: ProgramBackofficeMutations;
  dashboard: ProgramDashboardMutations;
};

export type ProgramProduction = {
  __typename?: 'ProgramProduction';
  awards?: Maybe<Scalars['String']['output']>;
  casting?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Scalars['String']['output']>;
  firstBroadcastDate?: Maybe<Scalars['Date']['output']>;
  imdb?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<LanguageIsoCode>;
  productionCountry?: Maybe<CountryIsoCode>;
};

export type ProgramPublicSeller = {
  __typename?: 'ProgramPublicSeller';
  legalName: Scalars['String']['output'];
};

export enum ProgramQuality {
  Hd = 'HD',
  Sd = 'SD'
}

export type ProgramQueries = {
  __typename?: 'ProgramQueries';
  catalog: CatalogProgram;
  dashboard: DashboardProgram;
};


export type ProgramQueriesCatalogArgs = {
  id: Scalars['UUID']['input'];
};


export type ProgramQueriesDashboardArgs = {
  id: Scalars['UUID']['input'];
};

export type ProgramSubtitle = {
  __typename?: 'ProgramSubtitle';
  language: LanguageIsoCode;
  sourceFile?: Maybe<BackofficeSourceFile>;
  sourceFileId: Scalars['UUID']['output'];
};

export type ProgramSubtitleInput = {
  language: LanguageIsoCode;
  sourceFileId: Scalars['UUID']['input'];
};

export type ProgramVideoTrack = {
  __typename?: 'ProgramVideoTrack';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  bitrate?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  quality?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<ProgramVideoTrackResolution>;
};

export type ProgramVideoTrackResolution = {
  __typename?: 'ProgramVideoTrackResolution';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProgramsQueries = {
  __typename?: 'ProgramsQueries';
  backoffice: SearchBackofficeProgramsOutput;
  catalog: SearchCatalogProgramsOutput;
  dashboard: SearchDashboardProgramsOutput;
};


export type ProgramsQueriesBackofficeArgs = {
  filter?: InputMaybe<SearchBackofficeProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
};


export type ProgramsQueriesCatalogArgs = {
  filter?: InputMaybe<SearchCatalogProgramsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
};


export type ProgramsQueriesDashboardArgs = {
  filter?: InputMaybe<SearchDashboardProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
};

export type PublicProgramLifecycle = {
  __typename?: 'PublicProgramLifecycle';
  rightExclusivity: Scalars['Boolean']['output'];
};

export type PublicSeller = {
  __typename?: 'PublicSeller';
  identifier: Identifier;
  legalName: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  businessProvider: BusinessProvider;
  businessProviders: PaginatedBusinessProvidersResult;
  buyer: BuyerQueries;
  buyers: BuyersQueries;
  cart: CurrentCart;
  categories: Array<Category>;
  claim: Claim;
  excludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  format: FormatQueries;
  formats: FormatsQueries;
  genres: Array<Genre>;
  license: License;
  program: ProgramQueries;
  programs: ProgramsQueries;
  searchClaims: SearchClaimOutput;
  searchExcludedCountriesTemplates: SearchExcludedCountriesTemplateOutput;
  searchLicenses: PaginatedLicensesResult;
  searchTransactions: PaginatedTransactionsResult;
  seller: SellerQueries;
  sellers: SellersQueries;
  sourceFile: SourceFileQueries;
  sourceFiles: SourceFilesQueries;
  transaction: Transaction;
};


export type QueryBusinessProviderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBusinessProvidersArgs = {
  filters?: InputMaybe<BusinessProviderFiltersInput>;
  order?: InputMaybe<BusinessProviderOrderByInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QueryBuyerArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCategoriesArgs = {
  contentType: ContentType;
};


export type QueryClaimArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryExcludedCountriesTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGenresArgs = {
  contentType: ContentType;
};


export type QueryLicenseArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySearchClaimsArgs = {
  filters?: InputMaybe<ClaimFiltersInput>;
  order?: InputMaybe<ClaimOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QuerySearchExcludedCountriesTemplatesArgs = {
  filters?: InputMaybe<ExcludedCountriesTemplateFiltersInput>;
  order?: InputMaybe<ExcludedCountriesTemplateOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QuerySearchLicensesArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainBroadcastCountry?: InputMaybe<LicenseIsoCode>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchTransactionsArgs = {
  buyerContactEmail?: InputMaybe<Scalars['String']['input']>;
  buyerContactName?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['UUID']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TransactionStatus>;
};


export type QuerySellerArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySourceFileArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['UUID']['input'];
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveFromCartInput = {
  language: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type SearchBackofficeBuyersOutput = {
  __typename?: 'SearchBackofficeBuyersOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeBuyerObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in seller legal name (ILIKE) */
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchBackofficeFormatsOutput = {
  __typename?: 'SearchBackofficeFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<FormatObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeProgramsFilterInput = {
  /** Filter by audio languages (OR) */
  audioLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by category UUIDs (OR) */
  category?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by duration range */
  duration?: InputMaybe<IntRangeInput>;
  /** Filter by episodes count range */
  episodesQuantity?: InputMaybe<IntRangeInput>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by licenses count range */
  licensesQuantity?: InputMaybe<IntRangeInput>;
  /** Filter by parent UUID (null = top-level only) */
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in seller legal name (ILIKE) */
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by subtitle languages (OR) */
  subtitleLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by content type (SINGLE | COLLECTION) */
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchBackofficeProgramsOutput = {
  __typename?: 'SearchBackofficeProgramsOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeProgram>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeSellersOutput = {
  __typename?: 'SearchBackofficeSellersOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeSellerObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeSourceFilesFilterInput = {
  /** Video and subtitle only */
  contentType?: InputMaybe<SourceFileContentType>;
  fileType?: InputMaybe<SourceFileFileType>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Video, subtitle, cover and credit only */
  ingestStatus?: InputMaybe<SourceFileIngestStatus>;
  /** Subtitle only */
  language?: InputMaybe<LanguageIsoCode>;
  /** Video, subtitle, cover and credit only */
  linkStatus?: InputMaybe<SourceFileLinkStatus>;
  maximumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  maximumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  minimumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  minimumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search in original filename (ILIKE) */
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  /** Metadata only */
  parseStatus?: InputMaybe<SourceFileParseStatus>;
  /** Filter by seller UUID (exact match) */
  seller?: InputMaybe<Scalars['UUID']['input']>;
  /** Search in seller legal name (ILIKE) */
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  uploadStatus?: InputMaybe<SourceFileUploadStatus>;
};

export type SearchBackofficeSourceFilesOutput = {
  __typename?: 'SearchBackofficeSourceFilesOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeSourceFile>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchCatalogFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by genre UUIDs (OR) */
  genres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Search in keywords (i18n ILIKE) */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Maximum first broadcast date (<=) */
  maxFirstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  /** Minimum first broadcast date (>=) */
  minFirstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by seller UUID */
  seller?: InputMaybe<Scalars['UUID']['input']>;
  /** Search in synopsis (i18n ILIKE) */
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchCatalogFormatsOrderByInput = {
  category?: InputMaybe<CatalogSearchDirection>;
  createdAt?: InputMaybe<CatalogSearchDirection>;
  identifier?: InputMaybe<CatalogSearchDirection>;
  productionCountry?: InputMaybe<CatalogSearchDirection>;
  timeslot?: InputMaybe<CatalogSearchDirection>;
  title?: InputMaybe<CatalogSearchDirection>;
  updatedAt?: InputMaybe<CatalogSearchDirection>;
};

export type SearchCatalogFormatsOutput = {
  __typename?: 'SearchCatalogFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<CatalogFormat>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchCatalogProgramsFilterInput = {
  /** Filter by audio languages (OR) */
  audioLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search in casting (ILIKE, OR with other text fields) */
  casting?: InputMaybe<Scalars['String']['input']>;
  /** Filter by category UUIDs (OR) */
  category?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Search in directors (ILIKE, OR with other text fields) */
  directors?: InputMaybe<Scalars['String']['input']>;
  /** Filter by episodes count range */
  episodesQuantity?: InputMaybe<IntRangeInput>;
  /** Exclude programs with these genre UUIDs */
  excludedGenres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by first broadcast date range */
  firstBroadcastDate?: InputMaybe<DateRangeInput>;
  /** Filter by genre UUIDs (OR) */
  genre?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Search in keywords (i18n ILIKE, OR with other text fields) */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Filter by parent UUID (null = top-level only) */
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by price range (buyer only) */
  price?: InputMaybe<FloatRangeInput>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by quality (HD | SD) */
  quality?: InputMaybe<ProgramQuality>;
  /** Filter by seller UUID */
  seller?: InputMaybe<Scalars['UUID']['input']>;
  /** Search in synopsis (i18n ILIKE, OR with other text fields) */
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** Search in title (i18n ILIKE, OR with other text fields) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by content type (SINGLE | COLLECTION) */
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchCatalogProgramsOrderByInput = {
  casting?: InputMaybe<CatalogSearchDirection>;
  createdAt?: InputMaybe<CatalogSearchDirection>;
  directors?: InputMaybe<CatalogSearchDirection>;
  duration?: InputMaybe<CatalogSearchDirection>;
  episodeNumber?: InputMaybe<CatalogSearchDirection>;
  episodesQuantity?: InputMaybe<CatalogSearchDirection>;
  firstBroadcastDate?: InputMaybe<CatalogSearchDirection>;
  identifier?: InputMaybe<CatalogSearchDirection>;
  keywords?: InputMaybe<CatalogSearchDirection>;
  licensesQuantity?: InputMaybe<CatalogSearchDirection>;
  price?: InputMaybe<CatalogSearchDirection>;
  productionCountry?: InputMaybe<CatalogSearchDirection>;
  synopsis?: InputMaybe<CatalogSearchDirection>;
  title?: InputMaybe<CatalogSearchDirection>;
};

export type SearchCatalogProgramsOutput = {
  __typename?: 'SearchCatalogProgramsOutput';
  count: Scalars['Int']['output'];
  items: Array<CatalogProgram>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchClaimOutput = {
  __typename?: 'SearchClaimOutput';
  claims: Array<Claim>;
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchDashboardFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchDashboardFormatsOutput = {
  __typename?: 'SearchDashboardFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<DashboardFormat>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchDashboardProgramsFilterInput = {
  /** Filter by audio languages (OR) */
  audioLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by category UUIDs (OR) */
  category?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by duration range */
  duration?: InputMaybe<IntRangeInput>;
  /** Filter by episodes count range */
  episodesQuantity?: InputMaybe<IntRangeInput>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by licenses count range */
  licensesQuantity?: InputMaybe<IntRangeInput>;
  /** Filter by parent UUID (null = top-level only) */
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by content type (SINGLE | COLLECTION) */
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchDashboardProgramsOutput = {
  __typename?: 'SearchDashboardProgramsOutput';
  count: Scalars['Int']['output'];
  items: Array<DashboardProgram>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchDashboardSourceFilesFilterInput = {
  /** Video and subtitle only */
  contentType?: InputMaybe<SourceFileContentType>;
  fileType?: InputMaybe<SourceFileFileType>;
  maximumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  maximumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  minimumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  minimumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search in original filename (ILIKE) */
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  uploadStatus?: InputMaybe<SourceFileUploadStatus>;
};

export type SearchDashboardSourceFilesOutput = {
  __typename?: 'SearchDashboardSourceFilesOutput';
  count: Scalars['Int']['output'];
  items: Array<DashboardSourceFile>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export enum SearchDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SearchExcludedCountriesTemplateOutput = {
  __typename?: 'SearchExcludedCountriesTemplateOutput';
  count: Scalars['Int']['output'];
  excludedCountriesTemplates: Array<ExcludedCountriesTemplateObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchFormatsOrderByInput = {
  category?: InputMaybe<SearchDirection>;
  createdAt?: InputMaybe<SearchDirection>;
  identifier?: InputMaybe<SearchDirection>;
  productionCountry?: InputMaybe<SearchDirection>;
  sellerLegalName?: InputMaybe<SearchDirection>;
  timeslot?: InputMaybe<SearchDirection>;
  title?: InputMaybe<SearchDirection>;
  updatedAt?: InputMaybe<SearchDirection>;
};

export type SearchFormatsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export type SearchProgramsOrderByInput = {
  casting?: InputMaybe<SearchDirection>;
  createdAt?: InputMaybe<SearchDirection>;
  directors?: InputMaybe<SearchDirection>;
  duration?: InputMaybe<SearchDirection>;
  episodeNumber?: InputMaybe<SearchDirection>;
  episodesQuantity?: InputMaybe<SearchDirection>;
  firstBroadcastDate?: InputMaybe<SearchDirection>;
  identifier?: InputMaybe<SearchDirection>;
  licensesQuantity?: InputMaybe<SearchDirection>;
  productionCountry?: InputMaybe<SearchDirection>;
  published?: InputMaybe<SearchDirection>;
  sellerLegalName?: InputMaybe<SearchDirection>;
  title?: InputMaybe<SearchDirection>;
  updatedAt?: InputMaybe<SearchDirection>;
  validated?: InputMaybe<SearchDirection>;
};

export type SearchProgramsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Seller = {
  __typename?: 'Seller';
  billingEmail: Scalars['EmailAddress']['output'];
  businessProvider?: Maybe<BusinessProvider>;
  commissionRate: Scalars['Float']['output'];
  contactEmail: Scalars['EmailAddress']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  payoutTemplate: Scalars['PayoutTemplate']['output'];
  postalAddress: Scalars['String']['output'];
  tenant: Tenant;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type SellerAccountMutations = {
  __typename?: 'SellerAccountMutations';
  update: AccountSellerObjectType;
};


export type SellerAccountMutationsUpdateArgs = {
  input: UpdateSellerAccountInput;
};

export type SellerBackofficeMutations = {
  __typename?: 'SellerBackofficeMutations';
  create: BackofficeSellerObjectType;
  update: BackofficeSellerObjectType;
};


export type SellerBackofficeMutationsCreateArgs = {
  input: CreateSellerInput;
};


export type SellerBackofficeMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateSellerInput;
};

export type SellerBusinessProvider = {
  __typename?: 'SellerBusinessProvider';
  contactName?: Maybe<Scalars['String']['output']>;
  identifier: Identifier;
};

export type SellerClaimFiltersInput = {
  legalName?: InputMaybe<Scalars['String']['input']>;
};

export type SellerMetrics = {
  __typename?: 'SellerMetrics';
  licensesQuantity: Scalars['Int']['output'];
  programsDuration: Scalars['Int']['output'];
  sourceFilesQuantity: Scalars['Int']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type SellerMutations = {
  __typename?: 'SellerMutations';
  account: SellerAccountMutations;
  backoffice: SellerBackofficeMutations;
};

export type SellerObjectType = {
  __typename?: 'SellerObjectType';
  businessProviderId?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SellerQueries = {
  __typename?: 'SellerQueries';
  account?: Maybe<AccountSellerObjectType>;
  backoffice?: Maybe<BackofficeSellerObjectType>;
};

export type SellerSearchFilterInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type SellerSearchOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type SellerSearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export type SellersQueries = {
  __typename?: 'SellersQueries';
  backoffice: SearchBackofficeSellersOutput;
};


export type SellersQueriesBackofficeArgs = {
  filter?: InputMaybe<SellerSearchFilterInput>;
  orderBy?: InputMaybe<SellerSearchOrderByInput>;
  pagination?: InputMaybe<SellerSearchPaginationInput>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceFileBackofficeMutations = {
  __typename?: 'SourceFileBackofficeMutations';
  delete: DeleteSourceFileOutput;
};


export type SourceFileBackofficeMutationsDeleteArgs = {
  id: Scalars['UUID']['input'];
};

export enum SourceFileContentType {
  Master = 'MASTER',
  Trailer = 'TRAILER'
}

export type SourceFileErrorLog = {
  __typename?: 'SourceFileErrorLog';
  createdAt: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

export enum SourceFileFileType {
  Cover = 'COVER',
  Credit = 'CREDIT',
  Metadata = 'METADATA',
  Subtitle = 'SUBTITLE',
  Video = 'VIDEO'
}

export enum SourceFileIngestStatus {
  Error = 'ERROR',
  Ingested = 'INGESTED',
  Ingesting = 'INGESTING',
  Pending = 'PENDING'
}

export enum SourceFileLinkStatus {
  Error = 'ERROR',
  Linked = 'LINKED',
  Linking = 'LINKING',
  Pending = 'PENDING'
}

export type SourceFileMutations = {
  __typename?: 'SourceFileMutations';
  backoffice: SourceFileBackofficeMutations;
};

export enum SourceFileParseStatus {
  Error = 'ERROR',
  Parsed = 'PARSED',
  Parsing = 'PARSING',
  Pending = 'PENDING'
}

export type SourceFileQueries = {
  __typename?: 'SourceFileQueries';
  backoffice: BackofficeSourceFile;
  dashboard: DashboardSourceFile;
};

export enum SourceFileUploadStatus {
  Error = 'ERROR',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export type SourceFilesOrderByInput = {
  contentType?: InputMaybe<SearchDirection>;
  createdAt?: InputMaybe<SearchDirection>;
  fileSize?: InputMaybe<SearchDirection>;
  fileType?: InputMaybe<SearchDirection>;
  identifier?: InputMaybe<SearchDirection>;
  ingestStatus?: InputMaybe<SearchDirection>;
  language?: InputMaybe<SearchDirection>;
  linkStatus?: InputMaybe<SearchDirection>;
  originalFileName?: InputMaybe<SearchDirection>;
  parseStatus?: InputMaybe<SearchDirection>;
  seller?: InputMaybe<SearchDirection>;
  sellerLegalName?: InputMaybe<SearchDirection>;
  updatedAt?: InputMaybe<SearchDirection>;
  uploadStatus?: InputMaybe<SearchDirection>;
};

export type SourceFilesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SourceFilesQueries = {
  __typename?: 'SourceFilesQueries';
  backoffice: SearchBackofficeSourceFilesOutput;
  dashboard: SearchDashboardSourceFilesOutput;
};


export type SourceFilesQueriesBackofficeArgs = {
  filter?: InputMaybe<SearchBackofficeSourceFilesFilterInput>;
  orderBy?: InputMaybe<SourceFilesOrderByInput>;
  pagination?: InputMaybe<SourceFilesPaginationInput>;
};


export type SourceFilesQueriesDashboardArgs = {
  filter?: InputMaybe<SearchDashboardSourceFilesFilterInput>;
  orderBy?: InputMaybe<SourceFilesOrderByInput>;
  pagination?: InputMaybe<SourceFilesPaginationInput>;
};

export type Subtitle = {
  __typename?: 'Subtitle';
  language: Scalars['String']['output'];
  sourceFile: LegacySourceFile;
};

export type Tenant = {
  __typename?: 'Tenant';
  cloudFrontUrl: Scalars['String']['output'];
  kmsKeyId?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  buyer: Buyer;
  cart: Cart;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  price: Scalars['Float']['output'];
  status: TransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export type TransactionBuyerOrderBy = {
  contactEmail?: InputMaybe<SortOrder>;
  contactName?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
};

export type TransactionOrderBy = {
  buyer?: InputMaybe<TransactionBuyerOrderBy>;
  buyerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum TransactionStatus {
  Error = 'ERROR',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export enum TransactionStatusInput {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export enum TranslateJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type UpdateBuyerAccountInput = {
  audioOutputFormat?: InputMaybe<AudioOutputFormat>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  broadcastCountries?: InputMaybe<BroadcastCountriesInput>;
  broadcastLanguage?: InputMaybe<LanguageIsoCode>;
  cognitoPassword?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  videoOutputBitrate?: InputMaybe<VideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<VideoOutputFormat>;
};

export type UpdateBuyerInput = {
  audioOutputFormat?: InputMaybe<AudioOutputFormat>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  broadcastCountries?: InputMaybe<BroadcastCountriesInput>;
  broadcastLanguage?: InputMaybe<LanguageIsoCode>;
  broadcastType?: InputMaybe<NestBroadcastType>;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  hourCost?: InputMaybe<Scalars['Float']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  licensesDuration?: InputMaybe<Scalars['Int']['input']>;
  payoutTemplate?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  replayRights?: InputMaybe<Scalars['Boolean']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  videoOutputBitrate?: InputMaybe<VideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<VideoOutputFormat>;
};

export type UpdateCartInput = {
  currentLanguage: LanguageIsoCode;
  newLanguage: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type UpdateExcludedCountriesTemplateInput = {
  excludedCountries?: InputMaybe<Array<ExcludedCountryInputType>>;
  templateId: Scalars['UUID']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormatInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  coverImageFileId?: InputMaybe<Scalars['UUID']['input']>;
  editorialization?: InputMaybe<EditorializationInput>;
  excludedCountries?: InputMaybe<Array<ExcludedCountryInput>>;
  firstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  frapaId?: InputMaybe<Scalars['String']['input']>;
  genreIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  masterFileId?: InputMaybe<Scalars['UUID']['input']>;
  otherProductionCountries?: InputMaybe<Array<OtherProductionCountryInput>>;
  productionCountry?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rightExclusivity?: InputMaybe<Scalars['Boolean']['input']>;
  timeslot?: InputMaybe<FormatTimeslot>;
  trailerFileId?: InputMaybe<Scalars['UUID']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProgramInput = {
  awards?: InputMaybe<Scalars['String']['input']>;
  casting?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  directors?: InputMaybe<Scalars['String']['input']>;
  editorialization?: InputMaybe<ProgramEditorializationInput>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedCountries?: InputMaybe<Array<ProgramExcludedCountryInput>>;
  firstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  genreIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  imdb?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSegmentable?: InputMaybe<Scalars['Boolean']['input']>;
  productionCountry?: InputMaybe<CountryIsoCode>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSellerAccountInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  cognitoPassword?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSellerInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  payoutTemplate?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadSourceFileContentType {
  Cover = 'Cover',
  Credit = 'Credit',
  Data = 'Data',
  Master = 'Master',
  SubtitleMaster = 'SubtitleMaster',
  SubtitleTrailer = 'SubtitleTrailer',
  Trailer = 'Trailer'
}

/** Uploaded part */
export type UploadedPart = {
  __typename?: 'UploadedPart';
  etag: Scalars['String']['output'];
  partNumber: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type UploadedPartInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export enum VideoOutputBitrate {
  B_2_5 = 'B_2_5',
  B_5 = 'B_5',
  B_25 = 'B_25',
  B_30 = 'B_30',
  B_50 = 'B_50'
}

export enum VideoOutputFormat {
  Mov = 'MOV',
  Mp4 = 'MP4',
  Mxf = 'MXF'
}

export enum VideoQuality {
  Hd = 'HD',
  Sd = 'SD',
  Unknown = 'UNKNOWN'
}

export type VideoTrack = {
  __typename?: 'VideoTrack';
  aspectRatio: Scalars['Float']['output'];
  bitrate: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  quality: VideoQuality;
  resolutionHeight: Scalars['Int']['output'];
  resolutionWidth: Scalars['Int']['output'];
};

export type BackofficeBusinessProvidersQueryVariables = Exact<{
  filters?: InputMaybe<BusinessProviderFiltersInput>;
  order?: InputMaybe<BusinessProviderOrderByInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type BackofficeBusinessProvidersQuery = { __typename?: 'Query', businessProviders: { __typename?: 'PaginatedBusinessProvidersResult', count: number, items: Array<{ __typename?: 'BusinessProvider', legalName: string, contactEmail: string, contactName: string, licensesQuantity: number, programsDuration: number, postalAddress: string, vatId: string, billingEmail: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, bankAccountDetails: { __typename?: 'BankAccountDetails', iban: string, bic: string } }> } };

export type BusinessProviderOptionsQueryVariables = Exact<{
  filters?: InputMaybe<BusinessProviderFiltersInput>;
  order?: InputMaybe<BusinessProviderOrderByInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type BusinessProviderOptionsQuery = { __typename?: 'Query', businessProviders: { __typename?: 'PaginatedBusinessProvidersResult', count: number, items: Array<{ __typename?: 'BusinessProvider', legalName: string, identifier: { __typename?: 'Identifier', id: string } }> } };

export type UpdateBusinessProviderMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
}>;


export type UpdateBusinessProviderMutation = { __typename?: 'Mutation', updateBusinessProvider: { __typename: 'BusinessProvider' } };

export type CreateBusinessProviderMutationVariables = Exact<{
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
}>;


export type CreateBusinessProviderMutation = { __typename?: 'Mutation', createBusinessProvider: { __typename: 'BusinessProvider' } };

export type DeleteBusinessProviderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBusinessProviderMutation = { __typename?: 'Mutation', deleteBusinessProvider: { __typename?: 'DeleteBusinessProviderResult', id: string, success: boolean } };

export type SearchBuyersQueryVariables = Exact<{
  filter?: InputMaybe<BuyerSearchFilterInput>;
  orderBy?: InputMaybe<BuyerSearchOrderByInput>;
  pagination?: InputMaybe<BuyerSearchPaginationInput>;
}>;


export type SearchBuyersQuery = { __typename?: 'Query', buyers: { __typename?: 'BuyersQueries', backoffice: { __typename?: 'SearchBackofficeBuyersOutput', count: number, items: Array<{ __typename?: 'BackofficeBuyerObjectType', billingEmail: string, broadcastLanguage: LanguageIsoCode, broadcastType: NestBroadcastType, contactEmail: string, contactName: string, hourCost: number, legalName: string, licensesDuration: number, payoutTemplate: any, postalAddress: string, publicName: string, vatId: string, videoOutputBitrate: VideoOutputBitrate, videoOutputFormat: VideoOutputFormat, broadcastCountries: { __typename?: 'BroadcastCountriesType', countries: Array<CountryIsoCode>, main: CountryIsoCode }, identifier: { __typename?: 'Identifier', id: string, sku: number }, businessProvider?: { __typename?: 'BuyerBusinessProvider', identifier: { __typename?: 'Identifier', id: string } } | null }> } } };

export type BuyerSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerSummaryQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', backoffice?: { __typename?: 'BackofficeBuyerObjectType', legalName: string } | null } };

export type UpdateBuyerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateBuyerInput;
}>;


export type UpdateBuyerMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', backoffice: { __typename?: 'BuyerBackofficeMutations', update: { __typename?: 'BackofficeBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CreateBuyerMutationVariables = Exact<{
  input: CreateBuyerInput;
}>;


export type CreateBuyerMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', backoffice: { __typename?: 'BuyerBackofficeMutations', create: { __typename?: 'BackofficeBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type BuyerProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerProfileQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', account?: { __typename?: 'AccountBuyerObjectType', contactName: string, contactEmail: string, publicName: string, postalAddress: string, billingEmail: string, legalName: string, vatId: string } | null } };

export type BuyerAuthContextQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerAuthContextQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', account?: { __typename?: 'AccountBuyerObjectType', contactName: string, contactEmail: string, broadcastLanguage: LanguageIsoCode, publicName: string, identifier: { __typename?: 'Identifier', id: string }, broadcastCountries: { __typename?: 'BroadcastCountriesType', main: CountryIsoCode, countries: Array<CountryIsoCode> } } | null } };

export type BuyerTechnicalSettingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerTechnicalSettingsQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', account?: { __typename?: 'AccountBuyerObjectType', videoOutputFormat: VideoOutputFormat, videoOutputBitrate: VideoOutputBitrate, broadcastLanguage: LanguageIsoCode, identifier: { __typename?: 'Identifier', id: string }, broadcastCountries: { __typename?: 'BroadcastCountriesType', main: CountryIsoCode, countries: Array<CountryIsoCode> } } | null } };

export type UpdateBuyerAccountMutationVariables = Exact<{
  input: UpdateBuyerAccountInput;
}>;


export type UpdateBuyerAccountMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', account: { __typename?: 'BuyerAccountMutations', update: { __typename?: 'AccountBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CartSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CartSummaryQuery = { __typename?: 'Query', cart: { __typename?: 'CurrentCart', quantity: number } };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart: { __typename?: 'CurrentCart', price: number, quantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: LanguageIsoCode, price: number, program: { __typename?: 'CatalogProgram', duration?: number | null, audioLanguages?: Array<LanguageIsoCode> | null, episodeNumber?: number | null, identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null, originalLanguage?: LanguageIsoCode | null } | null, parent?: { __typename?: 'CatalogProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null } } | null, publicSeller: { __typename?: 'ProgramPublicSeller', legalName: string } } }> } };

export type AddToCartMutationVariables = Exact<{
  input: AddToCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', addToCart: { __typename?: 'CurrentCart', price: number, quantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: LanguageIsoCode, price: number, program: { __typename?: 'CatalogProgram', duration?: number | null, audioLanguages?: Array<LanguageIsoCode> | null, episodeNumber?: number | null, identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null, originalLanguage?: LanguageIsoCode | null } | null, parent?: { __typename?: 'CatalogProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null } } | null, publicSeller: { __typename?: 'ProgramPublicSeller', legalName: string } } }> } } } };

export type RemoveFromCartMutationVariables = Exact<{
  input: RemoveFromCartInput;
}>;


export type RemoveFromCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', removeFromCart: { __typename?: 'CurrentCart', price: number, quantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: LanguageIsoCode, price: number, program: { __typename?: 'CatalogProgram', duration?: number | null, audioLanguages?: Array<LanguageIsoCode> | null, episodeNumber?: number | null, identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null, originalLanguage?: LanguageIsoCode | null } | null, parent?: { __typename?: 'CatalogProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null } } | null, publicSeller: { __typename?: 'ProgramPublicSeller', legalName: string } } }> } } } };

export type UpdateCartMutationVariables = Exact<{
  input: UpdateCartInput;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', updateCart: { __typename?: 'CurrentCart', price: number, quantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: LanguageIsoCode, price: number, program: { __typename?: 'CatalogProgram', duration?: number | null, audioLanguages?: Array<LanguageIsoCode> | null, episodeNumber?: number | null, identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null, originalLanguage?: LanguageIsoCode | null } | null, parent?: { __typename?: 'CatalogProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null } } | null, publicSeller: { __typename?: 'ProgramPublicSeller', legalName: string } } }> } } } };

export type GetProgramCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, title: string }> };

export type GetProgramCategoryDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramCategoryDetailsQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, title: string, catchPhrase: string, image: string }> };

export type GetFormatCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormatCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, title: string }> };

export type CreateClaimMutationVariables = Exact<{
  input: CreateClaimInput;
}>;


export type CreateClaimMutation = { __typename?: 'Mutation', createClaim: { __typename?: 'Claim', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type SearchBackofficeClaimsQueryVariables = Exact<{
  filters?: InputMaybe<ClaimFiltersInput>;
  order?: InputMaybe<ClaimOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type SearchBackofficeClaimsQuery = { __typename?: 'Query', searchClaims: { __typename?: 'SearchClaimOutput', count: number, limit: number, offset: number, claims: Array<{ __typename?: 'Claim', message: string, status: ClaimStatusOutput, createdAt: string, license?: { __typename?: 'License', seller: { __typename?: 'Seller', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, identifier: { __typename?: 'Identifier', id: string, sku: number }, buyer: { __typename?: 'Buyer', contactEmail: string, contactName: string, legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, program: { __typename?: 'Program', titles: import("./scalars").TitleMap, identifier: { __typename?: 'Identifier', id: string, sku: number } } } | null, identifier: { __typename?: 'Identifier', id: string, sku: number } }> } };

export type SearchBuyerOpenClaimsCountQueryVariables = Exact<{
  filters?: InputMaybe<ClaimFiltersInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type SearchBuyerOpenClaimsCountQuery = { __typename?: 'Query', searchClaims: { __typename?: 'SearchClaimOutput', count: number } };

export type UpdateClaimStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: ClaimStatusInput;
}>;


export type UpdateClaimStatusMutation = { __typename?: 'Mutation', updateClaimStatus: { __typename?: 'Claim', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type CreateExcludedCountriesTemplateMutationVariables = Exact<{
  input: CreateExcludedCountriesTemplateInput;
}>;


export type CreateExcludedCountriesTemplateMutation = { __typename?: 'Mutation', createExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, identifier: { __typename?: 'Identifier', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> } };

export type GetExclusionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExclusionTemplatesQuery = { __typename?: 'Query', searchExcludedCountriesTemplates: { __typename?: 'SearchExcludedCountriesTemplateOutput', count: number, excludedCountriesTemplates: Array<{ __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, identifier: { __typename?: 'Identifier', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> }> } };

export type UpdateExcludedCountriesTemplateMutationVariables = Exact<{
  input: UpdateExcludedCountriesTemplateInput;
}>;


export type UpdateExcludedCountriesTemplateMutation = { __typename?: 'Mutation', updateExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, identifier: { __typename?: 'Identifier', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> } };

export type DeleteExcludedCountriesTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DeleteExcludedCountriesTemplateMutation = { __typename?: 'Mutation', deleteExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', identifier: { __typename?: 'Identifier', id: string } } };

export type SearchFormatsQueryVariables = Exact<{
  filter?: InputMaybe<SearchCatalogFormatsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', catalog: { __typename?: 'SearchCatalogFormatsOutput', count: number, items: Array<{ __typename?: 'CatalogFormat', category?: { __typename?: 'Category', id: string, title: string } | null, files: { __typename?: 'CatalogFormatFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'EditorializationObjectType', synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string }, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: any | null } | null }> } } };

export type SearchFormatsDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsDashboardQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', dashboard: { __typename?: 'SearchDashboardFormatsOutput', count: number, items: Array<{ __typename?: 'DashboardFormat', timeslot: FormatTimeslot, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardFormatFiles', coverUrl?: string | null }, editorialization: { __typename?: 'EditorializationObjectType', synopsis: string, title: string }, genres: Array<{ __typename?: 'Genre', title: string, id: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean } | null, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: any | null, productionCountry?: string | null } | null }> } } };

export type SearchFormatsBoQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsBoQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', backoffice: { __typename?: 'SearchBackofficeFormatsOutput', count: number, items: Array<{ __typename?: 'FormatObjectType', timeslot: FormatTimeslot, category: { __typename?: 'Category', title: string }, files: { __typename?: 'FormatFiles', coverUrl?: string | null }, editorialization: { __typename?: 'EditorializationObjectType', title: string }, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean } | null, production?: { __typename?: 'ProductionObjectType', productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string, identifier: { __typename?: 'Identifier', id: string } } | null }> } } };

export type FormatQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', catalog: { __typename?: 'CatalogFormat', frapaId?: string | null, rightExclusivity: boolean, timeslot: FormatTimeslot, category?: { __typename?: 'Category', id: string, title: string } | null, files: { __typename?: 'CatalogFormatFiles', coverUrl?: string | null, masterUrl?: string | null, masterSubtitleUrl?: string | null, trailerUrl?: string | null, trailerSubtitleUrl?: string | null }, editorialization?: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string } | null, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, otherProductionCountries: Array<{ __typename?: 'OtherProductionCountryObjectType', countryIsoCode: string, year: string }>, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: any | null, productionCountry?: string | null } | null, seller?: { __typename?: 'PublicSeller', legalName: string } | null } } };

export type FormatDashboardQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatDashboardQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', dashboard?: { __typename?: 'DashboardFormat', frapaId?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardFormatFiles', coverUrl?: string | null, masterUrl?: string | null, masterSubtitleUrl?: string | null, trailerUrl?: string | null, trailerSubtitleUrl?: string | null }, editorialization: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string }, excludedCountries: Array<{ __typename?: 'FormatExcludedCountry', countryISOCode: string, exclusionType: string }>, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean, rightExclusivity: boolean } | null, otherProductionCountries: Array<{ __typename?: 'OtherProductionCountryObjectType', countryIsoCode: string, year: string }>, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: any | null, productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string } | null } | null } };

export type FormatAdminQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatAdminQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', dashboard?: { __typename?: 'DashboardFormat', frapaId?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardFormatFiles', coverUrl?: string | null, masterUrl?: string | null, masterSubtitleUrl?: string | null, trailerUrl?: string | null, trailerSubtitleUrl?: string | null }, editorialization: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string }, excludedCountries: Array<{ __typename?: 'FormatExcludedCountry', countryISOCode: string, exclusionType: string }>, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean, rightExclusivity: boolean } | null, otherProductionCountries: Array<{ __typename?: 'OtherProductionCountryObjectType', countryIsoCode: string, year: string }>, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: any | null, productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string } | null } | null } };

export type UpdateFormatMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateFormatInput;
}>;


export type UpdateFormatMutation = { __typename?: 'Mutation', format: { __typename?: 'FormatMutations', dashboard: { __typename?: 'FormatDashboardMutations', update: { __typename?: 'FormatObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type DeleteFormatMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteFormatMutation = { __typename?: 'Mutation', format: { __typename?: 'FormatMutations', backoffice: { __typename?: 'FormatBackofficeMutations', delete: { __typename?: 'DeleteOutput', id: string, success: boolean } } } };

export type GetProgramGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramGenresQuery = { __typename?: 'Query', genres: Array<{ __typename?: 'Genre', id: string, title: string }> };

export type GetFormatGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormatGenresQuery = { __typename?: 'Query', genres: Array<{ __typename?: 'Genre', id: string, title: string }> };

export type SearchLicensesQueryVariables = Exact<{
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  mainBroadcastCountry?: InputMaybe<LicenseIsoCode>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeContent?: Scalars['Boolean']['input'];
}>;


export type SearchLicensesQuery = { __typename?: 'Query', searchLicenses: { __typename?: 'PaginatedLicensesResult', count: number, limit: number, offset: number, licenses: Array<{ __typename?: 'License', clearanceDate: string, createdAt: string, endingDate?: string | null, price: number, buyer: { __typename?: 'Buyer', legalName: string, broadcastType: string, postalAddress: string, vatId: string, broadcastCountries: { __typename?: 'BroadcastCountries', countries: Array<CountryIsoCode> } }, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string, vatId: string }, program: { __typename?: 'Program', titles: import("./scalars").TitleMap, originalLanguage?: LanguageIsoCode | null, coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, firstBroadcastDate?: string | null, episodeNumber?: number | null, duration?: number | null, episodesQuantity?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'Program', coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, titles: import("./scalars").TitleMap, episodesQuantity?: number | null, firstBroadcastDate?: string | null, identifier: { __typename?: 'Identifier', id: string } } | null }, transaction: { __typename?: 'Transaction', createdAt: string }, assetBuilder?: { __typename?: 'AssetBuilder', status: string, audioLanguage: string, audioOutputFormat?: string | null, videoOutputBitrate: string, videoOutputFormat: string, subtitleLanguage: string, contents?: Array<{ __typename?: 'Contents', coverUrl?: string | null, subtitleUrl?: string | null, videoUrl: string, duration?: number | null, episodeNumber?: number | null, titles: import("./scalars").TitleMap }> } | null }> } };

export type SearchSellerLicensesQueryVariables = Exact<{
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  mainBroadcastCountry?: InputMaybe<LicenseIsoCode>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchSellerLicensesQuery = { __typename?: 'Query', searchLicenses: { __typename?: 'PaginatedLicensesResult', count: number, limit: number, offset: number, licenses: Array<{ __typename?: 'License', clearanceDate: string, createdAt: string, endingDate?: string | null, price: number, buyer: { __typename?: 'Buyer', legalName: string, publicName: string, broadcastLanguage: string, broadcastType: string, postalAddress: string, vatId: string, broadcastCountries: { __typename?: 'BroadcastCountries', main: CountryIsoCode, countries: Array<CountryIsoCode> } }, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string, vatId: string, postalAddress: string }, program: { __typename?: 'Program', titles: import("./scalars").TitleMap, originalLanguage?: LanguageIsoCode | null, coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, firstBroadcastDate?: string | null, episodeNumber?: number | null, duration?: number | null, episodesQuantity?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'Program', coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, titles: import("./scalars").TitleMap, episodesQuantity?: number | null, firstBroadcastDate?: string | null, identifier: { __typename?: 'Identifier', id: string } } | null }, transaction: { __typename?: 'Transaction', createdAt: string }, assetBuilder?: { __typename?: 'AssetBuilder', audioLanguage: string, subtitleLanguage: string } | null }> } };

export type SearchAdminLicensesQueryVariables = Exact<{
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAdminLicensesQuery = { __typename?: 'Query', searchLicenses: { __typename?: 'PaginatedLicensesResult', count: number, limit: number, offset: number, licenses: Array<{ __typename?: 'License', clearanceDate: string, createdAt: string, endingDate?: string | null, price: number, buyer: { __typename?: 'Buyer', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, program: { __typename?: 'Program', titles: import("./scalars").TitleMap, originalLanguage?: LanguageIsoCode | null, coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'Program', coverUrl?: string | null, isSegmentable: boolean, titles: import("./scalars").TitleMap, identifier: { __typename?: 'Identifier', id: string } } | null }, assetBuilder?: { __typename?: 'AssetBuilder', audioLanguage: string, audioOutputFormat?: string | null, videoOutputBitrate: string, videoOutputFormat: string, subtitleLanguage: string } | null }> } };

export type UpdateProgramLinkingMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: BackofficeUpdateProgramInput;
}>;


export type UpdateProgramLinkingMutation = { __typename?: 'Mutation', program: { __typename?: 'ProgramMutations', backoffice: { __typename?: 'ProgramBackofficeMutations', update: { __typename?: 'BackofficeProgram', emptyEpisodes?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'BackofficeProgram', emptyEpisodes?: number | null, identifier: { __typename?: 'Identifier', id: string } } | null } } } };

export type SearchProgramsWithSourcesBackofficeQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchProgramsWithSourcesBackofficeQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', backoffice: { __typename?: 'SearchBackofficeProgramsOutput', count: number, items: Array<{ __typename?: 'BackofficeProgram', episodeNumber?: number | null, episodesQuantity?: number | null, emptyEpisodes?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, seller: { __typename?: 'BackofficeSellerObjectType', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, parent?: { __typename?: 'BackofficeProgram', identifier: { __typename?: 'Identifier', id: string } } | null, files: { __typename?: 'BackofficeProgramFiles', masterFile?: { __typename?: 'BackofficeCoverSourceFile' } | { __typename?: 'BackofficeCreditSourceFile' } | { __typename?: 'BackofficeMetadataSourceFile' } | { __typename?: 'BackofficeSubtitleSourceFile' } | { __typename?: 'BackofficeVideoSourceFile', originalFileName: string, identifier: { __typename?: 'Identifier', id: string }, audioTracks: Array<{ __typename?: 'AudioTrack', trackNumber: number, mode: string, sampleRate: number, bitrate: string, languages: Array<{ __typename?: 'AudioTrackLanguage', code: LanguageIsoCode, dominant: boolean, duration: number, percentage: number }>, subtitleExtracted?: { __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } } | null, subtitlesTranslated: Array<{ __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } }> }> } | null, trailerFile?: { __typename?: 'BackofficeCoverSourceFile' } | { __typename?: 'BackofficeCreditSourceFile' } | { __typename?: 'BackofficeMetadataSourceFile' } | { __typename?: 'BackofficeSubtitleSourceFile' } | { __typename?: 'BackofficeVideoSourceFile', originalFileName: string, identifier: { __typename?: 'Identifier', id: string }, audioTracks: Array<{ __typename?: 'AudioTrack', trackNumber: number, mode: string, sampleRate: number, bitrate: string, languages: Array<{ __typename?: 'AudioTrackLanguage', code: LanguageIsoCode, dominant: boolean, duration: number, percentage: number }>, subtitleExtracted?: { __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } } | null, subtitlesTranslated: Array<{ __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } }> }> } | null, coverImageFile?: { __typename?: 'BackofficeCoverSourceFile', originalFileName: string, identifier: { __typename?: 'Identifier', id: string } } | { __typename?: 'BackofficeCreditSourceFile' } | { __typename?: 'BackofficeMetadataSourceFile' } | { __typename?: 'BackofficeSubtitleSourceFile' } | { __typename?: 'BackofficeVideoSourceFile' } | null, creditRollFile?: { __typename?: 'BackofficeCoverSourceFile' } | { __typename?: 'BackofficeCreditSourceFile', originalFileName: string, identifier: { __typename?: 'Identifier', id: string } } | { __typename?: 'BackofficeMetadataSourceFile' } | { __typename?: 'BackofficeSubtitleSourceFile' } | { __typename?: 'BackofficeVideoSourceFile' } | null, masterSubtitles: Array<{ __typename?: 'ProgramSubtitle', language: LanguageIsoCode, sourceFile?: { __typename: 'BackofficeCoverSourceFile' } | { __typename: 'BackofficeCreditSourceFile' } | { __typename: 'BackofficeMetadataSourceFile' } | { __typename: 'BackofficeSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, identifier: { __typename?: 'Identifier', id: string } } | { __typename: 'BackofficeVideoSourceFile' } | null }>, trailerSubtitles: Array<{ __typename?: 'ProgramSubtitle', language: LanguageIsoCode, sourceFile?: { __typename: 'BackofficeCoverSourceFile' } | { __typename: 'BackofficeCreditSourceFile' } | { __typename: 'BackofficeMetadataSourceFile' } | { __typename: 'BackofficeSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, identifier: { __typename?: 'Identifier', id: string } } | { __typename: 'BackofficeVideoSourceFile' } | null }> } }> } } };

export type SearchProgramsCatalogQueryVariables = Exact<{
  filter?: InputMaybe<SearchCatalogProgramsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchProgramsCatalogQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', catalog: { __typename?: 'SearchCatalogProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'CatalogProgram', episodesQuantity?: number | null, licensesQuantity: number, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'CatalogProgram', files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null } | null }> } } };

export type SearchProgramsDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchProgramsDashboardQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', dashboard: { __typename?: 'SearchDashboardProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodesQuantity?: number | null, licensesQuantity?: number | null, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'ProgramLifecycle', published: boolean, validated: boolean } | null, parent?: { __typename?: 'DashboardProgram', files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null } | null }> } } };

export type SearchProgramsAdminQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchProgramsAdminQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', dashboard: { __typename?: 'SearchDashboardProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodesQuantity?: number | null, licensesQuantity?: number | null, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'ProgramLifecycle', published: boolean, validated: boolean } | null, parent?: { __typename?: 'DashboardProgram', files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, production?: { __typename?: 'ProgramProduction', firstBroadcastDate?: any | null } | null }> } } };

export type SearchProgramsBackofficeQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchProgramsBackofficeQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', backoffice: { __typename?: 'SearchBackofficeProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'BackofficeProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodesQuantity?: number | null, files: { __typename?: 'BackofficeProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'ProgramLifecycle', published: boolean, validated: boolean } | null, parent?: { __typename?: 'BackofficeProgram', files: { __typename?: 'BackofficeProgramFiles', coverUrl?: string | null } } | null, seller: { __typename?: 'BackofficeSellerObjectType', legalName: string, identifier: { __typename?: 'Identifier', id: string } } }> } } };

export type SearchEpisodesCatalogQueryVariables = Exact<{
  filter?: InputMaybe<SearchCatalogProgramsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchEpisodesCatalogQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', catalog: { __typename?: 'SearchCatalogProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'CatalogProgram', duration?: number | null, episodeNumber?: number | null, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, files: { __typename?: 'CatalogProgramFiles', masterSubtitleUrl?: string | null, masterUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null } }> } } };

export type SearchEpisodesDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchEpisodesDashboardQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', dashboard: { __typename?: 'SearchDashboardProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'DashboardProgram', duration?: number | null, episodeNumber?: number | null, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, files: { __typename?: 'DashboardProgramFiles', masterSubtitleUrl?: string | null, masterUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null } }> } } };

export type SearchEpisodesAdminQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardProgramsFilterInput>;
  orderBy?: InputMaybe<SearchProgramsOrderByInput>;
  pagination?: InputMaybe<SearchProgramsPaginationInput>;
}>;


export type SearchEpisodesAdminQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramsQueries', dashboard: { __typename?: 'SearchDashboardProgramsOutput', count: number, limit: number, offset: number, items: Array<{ __typename?: 'DashboardProgram', duration?: number | null, episodeNumber?: number | null, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, files: { __typename?: 'DashboardProgramFiles', masterSubtitleUrl?: string | null, masterUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null } }> } } };

export type ProgramCatalogQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProgramCatalogQuery = { __typename?: 'Query', program: { __typename?: 'ProgramQueries', catalog: { __typename?: 'CatalogProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, isSegmentable?: boolean | null, licensesQuantity: number, price?: number | null, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null, creditRollUrl?: string | null, masterSubtitleUrl?: string | null, masterUrl?: string | null, trailerSubtitleUrl?: string | null, trailerUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'PublicProgramLifecycle', rightExclusivity: boolean } | null, parent?: { __typename?: 'CatalogProgram', audioLanguages?: Array<LanguageIsoCode> | null, files: { __typename?: 'CatalogProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null, production?: { __typename?: 'ProgramProduction', awards?: string | null, casting?: string | null, directors?: string | null, firstBroadcastDate?: any | null, imdb?: string | null, originalLanguage?: LanguageIsoCode | null, productionCountry?: CountryIsoCode | null } | null, publicSeller: { __typename?: 'ProgramPublicSeller', legalName: string } } } };

export type ProgramDashboardQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProgramDashboardQuery = { __typename?: 'Query', program: { __typename?: 'ProgramQueries', dashboard: { __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, isSegmentable?: boolean | null, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null, creditRollUrl?: string | null, masterSubtitleUrl?: string | null, masterUrl?: string | null, trailerSubtitleUrl?: string | null, trailerUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, excludedCountries: Array<{ __typename?: 'ProgramExcludedCountry', countryCode: CountryIsoCode, exclusionType: ExclusionType }>, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'ProgramLifecycle', published: boolean, rightExclusivity: boolean, validated: boolean } | null, parent?: { __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null, production?: { __typename?: 'ProgramProduction', awards?: string | null, casting?: string | null, directors?: string | null, firstBroadcastDate?: any | null, imdb?: string | null, originalLanguage?: LanguageIsoCode | null, productionCountry?: CountryIsoCode | null } | null } } };

export type ProgramAdminQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProgramAdminQuery = { __typename?: 'Query', program: { __typename?: 'ProgramQueries', dashboard: { __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, isSegmentable?: boolean | null, category: { __typename?: 'Category', id: string, title: string }, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null, creditRollUrl?: string | null, masterSubtitleUrl?: string | null, masterUrl?: string | null, trailerSubtitleUrl?: string | null, trailerUrl?: string | null, masterTechnicalDetails?: { __typename?: 'ProgramMasterTechnicalDetails', videoTrack?: { __typename?: 'ProgramVideoTrack', quality?: string | null, aspectRatio?: string | null, bitrate?: string | null, resolution?: { __typename?: 'ProgramVideoTrackResolution', width?: number | null, height?: number | null } | null } | null, audioTracks?: Array<{ __typename?: 'ProgramAudioTrack', mode?: string | null, sampleRate?: number | null, bitrate?: string | null, languageDominant?: string | null, languagesList?: Array<{ __typename?: 'ProgramAudioTrackLanguage', durationInSeconds?: number | null, languageCode?: string | null, percentage?: number | null }> | null }> | null } | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, excludedCountries: Array<{ __typename?: 'ProgramExcludedCountry', countryCode: CountryIsoCode, exclusionType: ExclusionType }>, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'ProgramLifecycle', published: boolean, rightExclusivity: boolean, validated: boolean } | null, parent?: { __typename?: 'DashboardProgram', audioLanguages?: Array<LanguageIsoCode> | null, files: { __typename?: 'DashboardProgramFiles', coverUrl?: string | null }, editorialization?: { __typename?: 'ProgramEditorialization', keywords?: Array<string> | null, synopsis: string, title: string } | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null, production?: { __typename?: 'ProgramProduction', awards?: string | null, casting?: string | null, directors?: string | null, firstBroadcastDate?: any | null, imdb?: string | null, originalLanguage?: LanguageIsoCode | null, productionCountry?: CountryIsoCode | null } | null } } };

export type UpdateProgramDashboardMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateProgramInput;
}>;


export type UpdateProgramDashboardMutation = { __typename?: 'Mutation', program: { __typename?: 'ProgramMutations', dashboard: { __typename?: 'ProgramDashboardMutations', update: { __typename?: 'DashboardProgram', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type DeleteProgramMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', program: { __typename?: 'ProgramMutations', backoffice: { __typename?: 'ProgramBackofficeMutations', delete: { __typename?: 'DeleteOutput', id: string, success: boolean } } } };

export type GetEpisodesPriceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  excludedEpisodeIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type GetEpisodesPriceQuery = { __typename?: 'Query', program: { __typename?: 'ProgramQueries', catalog: { __typename?: 'CatalogProgram', episodesPrice?: number | null } } };

export type SearchSellersQueryVariables = Exact<{
  filter?: InputMaybe<SellerSearchFilterInput>;
  orderBy?: InputMaybe<SellerSearchOrderByInput>;
  pagination?: InputMaybe<SellerSearchPaginationInput>;
}>;


export type SearchSellersQuery = { __typename?: 'Query', sellers: { __typename?: 'SellersQueries', backoffice: { __typename?: 'SearchBackofficeSellersOutput', count: number, items: Array<{ __typename?: 'BackofficeSellerObjectType', legalName: string, contactEmail: string, contactName: string, postalAddress: string, billingEmail: string, vatId: string, commissionRate: number, walletBalance: number, payoutTemplate: any, identifier: { __typename?: 'Identifier', sku: number, id: string }, businessProvider?: { __typename?: 'SellerBusinessProvider', identifier: { __typename?: 'Identifier', id: string } } | null }> } } };

export type SellerSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerSummaryQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', backoffice?: { __typename?: 'BackofficeSellerObjectType', legalName: string } | null } };

export type UpdateSellerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateSellerInput;
}>;


export type UpdateSellerMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', backoffice: { __typename?: 'SellerBackofficeMutations', update: { __typename?: 'BackofficeSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CreateSellerMutationVariables = Exact<{
  input: CreateSellerInput;
}>;


export type CreateSellerMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', backoffice: { __typename?: 'SellerBackofficeMutations', create: { __typename?: 'BackofficeSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type WalletWithdrawMutationVariables = Exact<{
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type WalletWithdrawMutation = { __typename?: 'Mutation', walletWithdraw: boolean };

export type SellerProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerProfileQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', account?: { __typename?: 'AccountSellerObjectType', legalName: string, postalAddress: string, billingEmail: string, vatId: string, contactEmail: string, contactName: string } | null } };

export type SellerAuthContextQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerAuthContextQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', account?: { __typename?: 'AccountSellerObjectType', contactName: string, contactEmail: string, identifier: { __typename?: 'Identifier', id: string } } | null } };

export type SellerDashboardMetricsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerDashboardMetricsQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', account?: { __typename?: 'AccountSellerObjectType', metrics: { __typename?: 'SellerMetrics', licensesQuantity: number, programsDuration: number, sourceFilesQuantity: number, walletBalance: number } } | null } };

export type UpdateSellerAccountMutationVariables = Exact<{
  input: UpdateSellerAccountInput;
}>;


export type UpdateSellerAccountMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', account: { __typename?: 'SellerAccountMutations', update: { __typename?: 'AccountSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type SearchSourceFilesListQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeSourceFilesFilterInput>;
  orderBy?: InputMaybe<SourceFilesOrderByInput>;
  pagination?: InputMaybe<SourceFilesPaginationInput>;
}>;


export type SearchSourceFilesListQuery = { __typename?: 'Query', sourceFiles: { __typename?: 'SourceFilesQueries', backoffice: { __typename?: 'SearchBackofficeSourceFilesOutput', count: number, items: Array<{ __typename: 'BackofficeCoverSourceFile', ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, sellerId: string, sellerLegalName?: string | null, createdAt: string, fileExtension: string, originalFileName: string, fileType: SourceFileFileType, fileSize: string, uploadStatus: SourceFileUploadStatus, updatedAt?: string | null, linkedProgram?: { __typename?: 'BackofficeProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, identifier: { __typename?: 'Identifier', sku: number, id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null } | { __typename: 'BackofficeCreditSourceFile', ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, sellerId: string, sellerLegalName?: string | null, createdAt: string, fileExtension: string, originalFileName: string, fileType: SourceFileFileType, fileSize: string, uploadStatus: SourceFileUploadStatus, updatedAt?: string | null, linkedProgram?: { __typename?: 'BackofficeProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, identifier: { __typename?: 'Identifier', sku: number, id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null } | { __typename: 'BackofficeMetadataSourceFile', parseStatus: SourceFileParseStatus, sellerId: string, sellerLegalName?: string | null, createdAt: string, fileExtension: string, originalFileName: string, fileType: SourceFileFileType, fileSize: string, uploadStatus: SourceFileUploadStatus, updatedAt?: string | null, identifier: { __typename?: 'Identifier', sku: number, id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null } | { __typename: 'BackofficeSubtitleSourceFile', contentType: SourceFileContentType, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, sellerId: string, sellerLegalName?: string | null, createdAt: string, fileExtension: string, originalFileName: string, fileType: SourceFileFileType, fileSize: string, uploadStatus: SourceFileUploadStatus, updatedAt?: string | null, linkedProgram?: { __typename?: 'BackofficeProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, subtitlesTranslated: Array<{ __typename?: 'GeneratedSubtitleSourceFile', language?: LanguageIsoCode | null, uploadStatus: SourceFileUploadStatus, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null }>, identifier: { __typename?: 'Identifier', sku: number, id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null } | { __typename: 'BackofficeVideoSourceFile', contentType: SourceFileContentType, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, mediainfo?: any | null, sellerId: string, sellerLegalName?: string | null, createdAt: string, fileExtension: string, originalFileName: string, fileType: SourceFileFileType, fileSize: string, uploadStatus: SourceFileUploadStatus, updatedAt?: string | null, linkedProgram?: { __typename?: 'BackofficeProgram', identifier: { __typename?: 'Identifier', id: string }, editorialization?: { __typename?: 'ProgramEditorialization', title: string } | null } | null, videoTrack?: { __typename?: 'VideoTrack', resolutionWidth: number, resolutionHeight: number, aspectRatio: number, bitrate: string } | null, audioTracks: Array<{ __typename?: 'AudioTrack', trackNumber: number, mode: string, sampleRate: number, bitrate: string, languages: Array<{ __typename?: 'AudioTrackLanguage', code: LanguageIsoCode, dominant: boolean, duration: number, percentage: number }>, subtitleExtracted?: { __typename?: 'GeneratedSubtitleSourceFile', language?: LanguageIsoCode | null, uploadStatus: SourceFileUploadStatus, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null } | null, subtitlesTranslated: Array<{ __typename?: 'GeneratedSubtitleSourceFile', language?: LanguageIsoCode | null, uploadStatus: SourceFileUploadStatus, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null }> }>, identifier: { __typename?: 'Identifier', sku: number, id: string }, errorsLog?: Array<{ __typename?: 'SourceFileErrorLog', message: string, error: string }> | null }> } } };

export type SearchSourceFilesBySellerIdQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeSourceFilesFilterInput>;
  orderBy?: InputMaybe<SourceFilesOrderByInput>;
  pagination?: InputMaybe<SourceFilesPaginationInput>;
}>;


export type SearchSourceFilesBySellerIdQuery = { __typename?: 'Query', sourceFiles: { __typename?: 'SourceFilesQueries', backoffice: { __typename?: 'SearchBackofficeSourceFilesOutput', items: Array<{ __typename: 'BackofficeCoverSourceFile', ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, originalFileName: string, fileType: SourceFileFileType, uploadStatus: SourceFileUploadStatus, identifier: { __typename?: 'Identifier', id: string, sku: number } } | { __typename: 'BackofficeCreditSourceFile', ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, originalFileName: string, fileType: SourceFileFileType, uploadStatus: SourceFileUploadStatus, identifier: { __typename?: 'Identifier', id: string, sku: number } } | { __typename: 'BackofficeMetadataSourceFile', parseStatus: SourceFileParseStatus, originalFileName: string, fileType: SourceFileFileType, uploadStatus: SourceFileUploadStatus, identifier: { __typename?: 'Identifier', id: string, sku: number } } | { __typename: 'BackofficeSubtitleSourceFile', contentType: SourceFileContentType, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, originalFileName: string, fileType: SourceFileFileType, uploadStatus: SourceFileUploadStatus, identifier: { __typename?: 'Identifier', id: string, sku: number } } | { __typename: 'BackofficeVideoSourceFile', contentType: SourceFileContentType, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, originalFileName: string, fileType: SourceFileFileType, uploadStatus: SourceFileUploadStatus, audioTracks: Array<{ __typename?: 'AudioTrack', trackNumber: number, mode: string, sampleRate: number, bitrate: string, languages: Array<{ __typename?: 'AudioTrackLanguage', code: LanguageIsoCode, dominant: boolean, duration: number, percentage: number }>, subtitleExtracted?: { __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } } | null, subtitlesTranslated: Array<{ __typename?: 'GeneratedSubtitleSourceFile', originalFileName: string, language?: LanguageIsoCode | null, ingestStatus: SourceFileIngestStatus, linkStatus: SourceFileLinkStatus, identifier: { __typename?: 'Identifier', id: string } }> }>, identifier: { __typename?: 'Identifier', id: string, sku: number } }> } } };

export type DeleteSourceFileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSourceFileMutation = { __typename?: 'Mutation', sourceFile: { __typename?: 'SourceFileMutations', backoffice: { __typename?: 'SourceFileBackofficeMutations', delete: { __typename?: 'DeleteSourceFileOutput', id: string, success: boolean } } } };

export type SearchBuyerTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
}>;


export type SearchBuyerTransactionsQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'PaginatedTransactionsResult', count: number, transactions: Array<{ __typename?: 'Transaction', price: number, status: TransactionStatus, createdAt: string, identifier: { __typename?: 'Identifier', sku: number } }> } };

export type SearchBackofficeTransactionsQueryVariables = Exact<{
  buyerContactEmail?: InputMaybe<Scalars['String']['input']>;
  buyerContactName?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['UUID']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TransactionStatus>;
}>;


export type SearchBackofficeTransactionsQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'PaginatedTransactionsResult', count: number, transactions: Array<{ __typename?: 'Transaction', price: number, status: TransactionStatus, createdAt: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, buyer: { __typename?: 'Buyer', legalName: string, contactName: string, contactEmail: string, identifier: { __typename?: 'Identifier', id: string, sku: number } } }> } };

export type TransactionCartContentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TransactionCartContentQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', cart: { __typename?: 'Cart', programs: Array<{ __typename?: 'CartProgram', program: { __typename?: 'Program', titles: import("./scalars").TitleMap, duration?: number | null, episodesQuantity?: number | null, episodeNumber?: number | null, coverUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string }, parent?: { __typename?: 'Program', titles: import("./scalars").TitleMap, episodesQuantity?: number | null, coverUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null } }> } } };

export type CreateTransactionMutationVariables = Exact<{
  cartId: Scalars['UUID']['input'];
  videoOutputBitrate: BuyerVideoOutputBitrate;
  videoOutputFormat: BuyerVideoOutputFormat;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'Transaction', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type UpdateTransactionStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: TransactionStatusInput;
}>;


export type UpdateTransactionStatusMutation = { __typename?: 'Mutation', updateTransactionStatus: { __typename?: 'Transaction', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type TransactionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TransactionQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', price: number, status: TransactionStatus, identifier: { __typename?: 'Identifier', sku: number }, buyer: { __typename?: 'Buyer', payinIban: string } } };
